import React from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemText,
  ListItemIcon,
  IconButton,
  Divider,
  Fade,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const HintPanel = ({ hints, onUseHint, onClose }) => {
  const theme = useTheme();
  
  return (
    <Fade in={true}>
      <Paper
        elevation={4}
        sx={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          right: 16,
          maxHeight: '40vh',
          borderRadius: 3,
          overflow: 'hidden',
          zIndex: 10,
          border: `1px solid ${theme.palette.divider}`
        }}
      >
        {/* Header */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          p: 1.5,
          bgcolor: 'primary.main',
          color: 'primary.contrastText'
        }}>
          <AutoFixHighIcon sx={{ mr: 1.5 }} />
          <Typography variant="subtitle2" sx={{ flexGrow: 1, fontWeight: 600 }}>
            Suggested Responses
          </Typography>
          <IconButton 
            size="small" 
            onClick={onClose}
            sx={{ color: 'inherit' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        
        <Divider />
        
        {/* Hint list */}
        <List sx={{ 
          p: 0,
          overflow: 'auto',
          maxHeight: 'calc(40vh - 57px)' // Adjusted for header height
        }}>
          {hints && hints.length > 0 ? (
            hints.map((hint, index) => (
              <React.Fragment key={index}>
                {index > 0 && <Divider variant="inset" component="li" />}
                <ListItem disablePadding>
                  <ListItemButton 
                    onClick={() => onUseHint(hint)}
                    sx={{ 
                      py: 1.75,
                      px: 2,
                      '&:hover': { 
                        bgcolor: theme.palette.action.hover
                      }
                    }}
                  >
                    <ListItemText 
                      primary={hint} 
                      primaryTypographyProps={{ 
                        variant: 'body2',
                        fontWeight: 500
                      }} 
                    />
                    <ListItemIcon sx={{ minWidth: 'auto', ml: 1 }}>
                      <ContentCopyIcon fontSize="small" color="action" />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              </React.Fragment>
            ))
          ) : (
            <ListItem>
              <ListItemText 
                primary="No suggestions available right now."
                primaryTypographyProps={{ 
                  variant: 'body2',
                  align: 'center',
                  color: 'text.secondary',
                  py: 2
                }}
              />
            </ListItem>
          )}
        </List>
      </Paper>
    </Fade>
  );
};

export default HintPanel;